import { createStyles, makeStyles } from '@material-ui/core/styles';

import LoopIcon from '@material-ui/icons/Loop';

const useStyles = makeStyles(() =>
  createStyles({
    loadingWrapper: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      margin: '50px auto',
    },
    heading: {
      margin: 0,
      marginTop: 10,
    },
    loadingIcon: {
      fontSize: 80,
      animation: '$rotation 2s infinite linear reverse',
      marginBottom: 0,
    },
    '@keyframes rotation': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(359deg)',
      },
    },
  })
);

export const Loading: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.loadingWrapper}>
      <LoopIcon className={classes.loadingIcon} />
      <h1 className={classes.heading}>Menu Loading</h1>
    </div>
  );
};

export default Loading;
